<template>
  <div class="flex flex-col justify-center">
    <div class="flex items-center">
      <span class="font-mono text-base">{{ title }}: {{ trackingId }}</span>
    </div>
    <MTooltip>
      <template v-slot:trigger>
        <MButton
          style="
            width: fit-content !important;
            background-color: var(--page-background-color) !important;
          "
          variant="neutral-lighter"
          class="flex items-center justify-end my-2"
          @click="copyTrackingId"
          @mouseleave="copied = false"
        >
          <MIcon name="copy" class="action-menu-icon current-color" />
          <span class="text-sm">{{ copy }} {{ title }}</span>
        </MButton>
      </template>
      {{ copied ? copiedText : copyText }}
    </MTooltip>
  </div>
</template>

<script>
import { copyToClipboard } from '@utils/copy-to-clipboard'
export default {
  name: 'DownloadFailedNotification',
  props: {
    trackingId: { type: [String, Number], required: true },
    copyText: { type: String, required: true },
    copiedText: { type: String, required: true },
    title: { type: String, required: true },
    copy: { type: String, required: true },
  },
  data() {
    return {
      copied: false,
    }
  },
  methods: {
    copyTrackingId() {
      copyToClipboard(this.trackingId)
      this.copied = true
    },
  },
}
</script>
